import { Text } from 'ui-kit/typography'
import { differencePointData } from './pointData'
import { DifferencePointCard } from './DifferencePointCard'
import classes from './DifferencePoint.module.scss'

export const DifferencePoint = () => {
  return (
    <article className={classes.article}>
      <div className={classes.heading}>
        <Text size={'lg'} center balance className={classes.tagline}>
          Point-to-point does not work anymore
        </Text>
        <Text size={'lg'} center balance className={classes.subtitle}>
          Embedded iPaaS are great for building point-to-point integrations. We
          take it further and let you build one-to-many integrations, removing
          the need to re-implement every use case for every app you want to
          integrate with.
        </Text>
      </div>

      <ul className={classes.list}>
        {differencePointData.map((item, idx) => (
          <DifferencePointCard key={idx} item={item} />
        ))}
      </ul>
    </article>
  )
}
